import { render, staticRenderFns } from "./BotaoSubmit.vue?vue&type=template&id=04002128"
import script from "./BotaoSubmit.vue?vue&type=script&lang=js"
export * from "./BotaoSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports